var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivePollGradebookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5168_94631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4002 1.20001V12L13.8002 9.30001L10.2002 12V1.20001",
    stroke: "#42296E",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.00002 21.9C2.99854 21.545 3.06736 21.1933 3.20252 20.865C3.33768 20.5368 3.5365 20.2385 3.78752 19.9875C4.03853 19.7365 4.33677 19.5377 4.66502 19.4025C4.99327 19.2674 5.34504 19.1985 5.70002 19.2H21V1.20004H5.70002C5.34504 1.19855 4.99327 1.26737 4.66502 1.40253C4.33677 1.53769 4.03853 1.73651 3.78752 1.98753C3.5365 2.23854 3.33768 2.53678 3.20252 2.86503C3.06736 3.19328 2.99854 3.54505 3.00002 3.90004V21.9Z",
    stroke: "#42296E",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21.9V22.8H19.2",
    stroke: "#42296E",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5168_94631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#42296E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePollGradebookIcon);
export default __webpack_public_path__ + "static/media/active_poll_gradebook_icon.0b7b6f69786f7fddfc41417499c52b05.svg";
export { ForwardRef as ReactComponent };